export default __webpack_public_path__ + "static/media/assistant33.d3b8a5c5.png";